/** =========================================================
 * Project attributes controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-project-attributes')
    .controller('ProjectAttributesController', ProjectAttributesController);

  ProjectAttributesController.$inject = ['$rootScope', '$scope', '$api', '$state', '$stateParams'];

  function ProjectAttributesController($rootScope, $scope, $api, $state, $stateParams) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;

      Raven.captureBreadcrumb({
        message: 'Page project attributes',
        data: {
          filters: $stateParams.filters
        }
      });

      vm.tableConfig = {
        model: 'project_attribute',
        getDataParams: {
          order: {
            id: 'desc'
          }
        },
        filters: angular.copy($stateParams.filters),
        fields: [{
          title: 'Title',
          key: 'name',
          order: true
        }],
        add: {
          template: 'app/views/dialogs/item-project-attribute.html'
        },
        edit: {
          template: 'app/views/dialogs/item-project-attribute.html'
        },
        delete: {}
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
